<template>
  <div id="Amount">
    <div class="line" v-if="type=='line'">
      <div class="title">
        {{title}}
      </div>
      <div class="amount">
        <span>
          <template v-if="offerStatus === 'completed' && amount > 0">
            <ICountUp :endVal="amount||0" :delay="500"/>
          </template>
          <template v-else>
            -
          </template>
          원
        </span>
      </div>
    </div>
    <div class="subline" v-else-if="type=='subline'">
      <div class="title">
        {{title}}
      </div>
      <div class="amount">
        <span>
          <template v-if="offerStatus === 'completed' && amount > 0">
            <ICountUp :endVal="amount||0" :delay="500"/>
          </template>
          <template v-else>
            -
          </template>
          원
        </span>
      </div>
    </div>
    <div class="normal" v-else>
      <span class="amount" >
        <template v-if="offerStatus === 'completed' && amount > 0">
          <ICountUp :endVal="amount||0" :delay="500"/>
        </template>
        <template v-else>
          -
        </template>
        원
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Amount',
  props: ['title', 'amount', 'type', 'offerStatus'],
  computed: {
    ...mapGetters('status', {
      status: 'getStatus'
    }),
  },
  methods: {},
  created() {}
}
</script>

<style lang="scss" scoped>
  #Amount {
    width: 100%;
    font-weight: 900;
    font-size: 27px;
    letter-spacing: -0.59px;
    text-align: center;
    color: #333333;
    .line {
      width: 100%;
      .title {
        font-weight: 700;
        font-size: 14px;
        line-height: 25px;
        color: #333333;
      }
      .amount {
        float: right;
        font-weight: 900;
        font-size: 22px;
        line-height: 25px;
        letter-spacing: -0.48px;
        text-align: right;
        color: #333333;
        & * {
          float: left;
        }
      }
    }
    .subline {
      width: 100%;
      height: 42px;
      border-radius: 6px;
      background-color: #f2f9ff;
      padding: 11px 15px;
      margin-top: 14px;
      .title {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #727d8c;
      }
      .amount {
        float: right;
        font-weight: 900;
        font-size: 18px;
        line-height: 20px;
        text-align: right;
        color: #333333;
        & * {
          float: left;
        }
      }
    }
    .normal {
      width: 100%;
      font-weight: 900;
      font-size: 35px;
      letter-spacing: -1px;
      color: #333333;
      margin-top: 7px;
      text-align: center;
      .amount {
        display: inline-block;
        float: none;
        & * {
          float: left;
        }
      }
    }
  }
</style>
